import { render, staticRenderFns } from "./concave-radius-box.vue?vue&type=template&id=5ac523c0&scoped=true"
import script from "./concave-radius-box.vue?vue&type=script&lang=ts"
export * from "./concave-radius-box.vue?vue&type=script&lang=ts"
import style0 from "./concave-radius-box.vue?vue&type=style&index=0&id=5ac523c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac523c0",
  null
  
)

export default component.exports